// Hybrid tenants pair AAD with a second provider (SAML2 or custom), so the
// provider can only be resolved once the user supplies a username. They are
// routed to the pre-login screen instead of straight into their provider.
const HYBRID_IDENTITY_TYPE = 2;
const HYBRID_TENANT_STORAGE_KEY = "isHybridTenant";

export const isHybridTenantDetails = (tenantDetails) =>
  Number(tenantDetails?.SAMLConfig?.IdentityType) === HYBRID_IDENTITY_TYPE &&
  ["SAML2", "custom"].includes(tenantDetails?.SecurityProviderName);

export const setHybridTenantSession = (isHybrid) => {
  if (isHybrid) {
    localStorage.setItem(HYBRID_TENANT_STORAGE_KEY, "true");
  } else {
    localStorage.removeItem(HYBRID_TENANT_STORAGE_KEY);
  }
};

export const isHybridTenantSession = () =>
  localStorage.getItem(HYBRID_TENANT_STORAGE_KEY) === "true";

export const restoreHybridCustomTenantMarker = (isHybridCustomTenant) => {
  if (isHybridCustomTenant) {
    localStorage.setItem(HYBRID_TENANT_STORAGE_KEY, "true");
  }
};
